import { useState, useCallback } from "react";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";

import { useDispatch } from 'react-redux'
import { setStartRoomTour } from "../../new-user-experience/actions/onboarding-actions";
import { waitForElement } from "../helpers/global-helpers";


const useProspectorTour = ({setShowShareElements, setShowQueryDrawer}) => {
  const dispatch = useDispatch();
// Need to have different copies for whether it is in draft state or in active state
// Check displayed in host or guest perspective. 
// For example: Lead generation and get in touch with person

  const [driverObj, setDriverObj] = useState(null);

  const startProspectorTour = useCallback(() => {
    const tour = driver({
      showProgress: true,
      allowClose: false,
      showButtons: ["next"],
      overlayColor: "rgba(0, 0, 0, 0.5)",
      popoverOffset: 25,
      onDestroyed: () => {
        dispatch(setStartRoomTour(false));
      },
      onReset: () => {dispatch(setStartRoomTour(false))},
      onHighlighted: () => {dispatch(setStartRoomTour(true))},
      steps: [
        {
          element: '[data-driver="prospector-tour-step-1"]',
          popover: {
            title: "About this Prospector",
            description: `
            <div>
              <div style="margin-bottom: 1em;">Its title would tell you quickly what this Prospector is intended for</div>
            </div>`
          },
         
                      
        },

        {
          element: '[data-driver="prospector-tour-step-4"]',
          popover: {
            title: "Customised content for your audiences",
            description: "Create custom pages containing curated content relevant to your stakeholders",
            onNextClick: async () => {
              if (setShowShareElements) {
                setShowShareElements(true);
                await waitForElement('[data-driver="prospector-tour-step-2"]');
                tour.moveNext();
              } 
            }
           
          },
        },
        {
          element: '[data-driver="prospector-tour-step-2"]',
          popover: {
            title: "Easy sharing",
            description: `
            <div>
              <div style="margin-bottom: 1em;">
                 Know someone who would benefit from it?
              </div>
              <div>
             Share the QR code or the link with them! 
               </div>
            </div>`,
            onNextClick: () => {
                setShowShareElements(false);
                tour.moveNext();
            }
          },
        },
        {
          element: '[data-driver="prospector-tour-step-3A"]',
          popover: { title: "Need to get hold of someone?", description: "Great! Use this button...",
            onNextClick: async () => {
              if (setShowQueryDrawer) {
                setShowShareElements(false);
                setShowQueryDrawer(true)
                await waitForElement('[data-driver="prospector-tour-step-3B"]');
                tour.moveNext();
              } 
            }

          },
        },
        {
          element: '[data-driver="prospector-tour-step-3B"]',
          popover: { title: "Connect directly", description: "... and send a note to Prospector owner and let them know it makes sense to connect further",
            onNextClick: () => {
              if (setShowQueryDrawer) {
                setShowQueryDrawer(false)
                tour.moveNext();
              } 
            }

          },
        },
        {
          element: '[data-driver="prospector-tour-step-5"]',
          popover: {
            title: "Need to head elsewhere?",
            description: `When you are done with the Prospector, use this button to get back to your homepage, manage your profile, or to log out.`,
          },
        },
      ],
    });

    setDriverObj(tour);
    tour.drive();

  }, [dispatch, setShowShareElements, setShowQueryDrawer]);

  const stopProspectorTour = useCallback(() => {
    if (driverObj) {
      driverObj.stop();
    }
  }, [driverObj]);

  return { startProspectorTour, stopProspectorTour };
};

export default useProspectorTour